import { useAccount, useConnect, useDisconnect } from "wagmi";
import WalletModal from "@/components/WalletModal/Modal";
import DisConnectModal from "@/components/DisConnectModal/Modal";
import PhoneImg from '@/assets/svg/phone.svg'
import ArbImg from '@/assets/svg/arb.svg'
import zkImg from '@/assets/imgs/zksync.png'
import ExitSvg from '@/assets/svg/exit.svg'
import { ReactSVG } from 'react-svg'
import { masacAddress, getChainId } from '@/utils/index'
import styled from "styled-components";
import React, { useState, useEffect, useRef } from 'react';

export default function Profile() {
  const chainId = getChainId().id
  const { address, connector, isConnected } = useAccount();
  const { connect, connectors, error, isLoading, pendingConnector } =
    useConnect({
      chainId: chainId,
    });
  const { disconnect } = useDisconnect();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);


  const [showDiv2, setShowDiv2] = useState(false);
  const div2Ref = useRef(null);

  const toArb = ()=>{
    if(window.location.href.includes('test.junglefi')) return
    window.open('https://test.junglefi.io', '_blank');
  }

  const toZK = ()=>{
    if(window.location.href.includes('zks')) return
    window.open( 'https://testzks.junglefi.io', '_blank');
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (div2Ref.current && !div2Ref.current.contains(event.target)) {
        setShowDiv2(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDiv1Click = () => {
    setShowDiv2(!showDiv2);
  };

  if (isConnected) {
    return (
      <div>        
        <DisConnectModal handleClose={() => setIsOpen2(false)} isOpen={isOpen2}/>         
        <Btns>
          <div className="net-works">
            <NetWorkBtn onClick={handleDiv1Click}>
                <span className="network">{ chainId === 421613 ? 'Arbitrum Testnet' : 'ZkSync Testnet'}</span>
            </NetWorkBtn>
            {
              showDiv2 && <div className="networks" ref={div2Ref}>
                <div className="menu-item" onClick={toArb}>
                  <svg className="cm-img arb-img" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.2144 8.33159L11.4653 6.20895L14.8371 11.4606L14.8387 12.4685L14.8277 5.53318C14.8197 5.36365 14.7297 5.20857 14.5861 5.11711L8.51562 1.62528C8.3737 1.55546 8.19354 1.55627 8.0518 1.62749C8.03264 1.63703 8.01461 1.64749 7.99749 1.65889L7.97629 1.67219L2.08399 5.08672L2.06115 5.09711C2.03174 5.11062 2.00199 5.12781 1.97414 5.14777C1.86239 5.22787 1.78822 5.34635 1.76422 5.47926C1.76061 5.49939 1.75794 5.51988 1.75671 5.54062L1.76598 11.1922L4.90661 6.32435C5.30205 5.67889 6.16353 5.47098 6.96329 5.48227L7.90191 5.50704L2.3713 14.3766L3.02325 14.7519L8.62007 5.51606L11.0939 5.50708L5.51151 14.976L7.83785 16.3141L8.11579 16.4739C8.23336 16.5217 8.37198 16.5241 8.49054 16.4813L14.6463 12.9139L13.4694 13.5959L10.2144 8.33159ZM10.6916 15.2056L8.34202 11.5179L9.77633 9.08406L12.8621 13.9478L10.6916 15.2056Z" fill="#2D374B"/>
                    <path d="M8.34204 11.5179L10.6916 15.2057L12.8621 13.9478L9.77631 9.08405L8.34204 11.5179Z" fill="#28A0F0"/>
                    <path d="M14.8388 12.4685L14.8372 11.4606L11.4654 6.20892L10.2145 8.33156L13.4694 13.5958L14.6463 12.9138C14.7618 12.8201 14.8316 12.6825 14.839 12.534L14.8388 12.4685Z" fill="#28A0F0"/>
                    <path d="M0.709351 13.4189L2.37129 14.3766L7.90187 5.50708L6.96324 5.48231C6.16348 5.47101 5.30197 5.67892 4.90656 6.32438L1.76593 11.1922L0.709351 12.8157V13.4189Z" fill="white"/>
                    <path d="M11.094 5.50708L8.62014 5.51606L3.02332 14.7519L4.97958 15.8782L5.51158 14.976L11.094 5.50708Z" fill="white"/>
                    <path d="M15.8812 5.49433C15.8605 4.97697 15.5804 4.50336 15.1416 4.22763L8.99158 0.690886C8.55754 0.472342 8.01534 0.472062 7.58053 0.690746C7.52913 0.716674 1.59977 4.15546 1.59977 4.15546C1.51771 4.19482 1.43866 4.2417 1.36432 4.29492C0.972628 4.57563 0.733875 5.01188 0.709351 5.49114V12.8157L1.76593 11.1922L1.75671 5.54065C1.75793 5.51998 1.76053 5.49963 1.76421 5.47956C1.78811 5.34659 1.86235 5.22797 1.97413 5.1478C2.00202 5.12784 8.03267 1.63706 8.05183 1.62748C8.19357 1.55629 8.37373 1.55545 8.51565 1.62527L14.5861 5.11703C14.7297 5.2085 14.8197 5.36357 14.8277 5.5331V12.534C14.8204 12.6825 14.7617 12.82 14.6463 12.9138L13.4694 13.5958L12.8621 13.9477L10.6917 15.2056L8.49053 16.4812C8.37198 16.524 8.23335 16.5216 8.11579 16.4738L5.5115 14.9759L4.97951 15.8782L7.31988 17.2257C7.39728 17.2697 7.46622 17.3087 7.52281 17.3405C7.61042 17.3896 7.67014 17.4225 7.69122 17.4327C7.85756 17.5135 8.09691 17.5605 8.31258 17.5605C8.51032 17.5605 8.70314 17.5242 8.88558 17.4528L15.2789 13.7502C15.6459 13.4659 15.8618 13.0371 15.8812 12.5726V5.49433Z" fill="#96BEDC"/>
                  </svg>
                  <span className="network-txt">Arbitrum Testnet</span>
                </div>
                <div className="menu-item" onClick={toZK}>                  
                  <img className="cm-img zk-img" src={zkImg} alt="" />
                  <span className="network-txt">ZkSync Testnet</span>
                </div>
              </div>
            }
          </div>
          
          <ConnectBtn onClick={() => setIsOpen2(true)}>
              <span className="btn-text">{masacAddress(address)}</span>
              <ReactSVG
               src={ExitSvg}
               className="exit-svg"
               beforeInjection={(svg) => {                
                svg.setAttribute('style', 'display: flex')
              }}
               />
            </ConnectBtn>
        </Btns>
      </div>
    );
  }

  return (
    <>    
      <ConnectBtn2 onClick={() => setIsOpen(true)}>
        <span className="btn-text">Connect</span>
      </ConnectBtn2>
      <WalletModal handleClose={() => setIsOpen(false)} isOpen={isOpen} />      
    </>
  );
}

const Btns = styled.div`
  display: flex;  
  color: #32DE86;
  font-weight: 600;
  font-size: 16px;
  .net-works{
    position: relative;
    .networks{
      width: 181px;
      height: 133px;
      background: #232323;
      border-radius: 14px;
      position: absolute;
      right: -6px;
      top: 55px;
      box-sizing: border-box;
      padding-top: 16px;
      .menu-item{
        display: flex;
        align-items: center;
        height: 50px;
        line-height: 50px;        
        padding-left: 18px;
        cursor: pointer;
        &:hover{
          background: #333;
        }
      }
      .cm-img{
        margin-right: 8px;
        width: 30px;
        height: 30px;
        border-radius:50%;
      }
      .network-txt{
        font-weight: 500;
        font-size: 14px;
        color: #fff;
      }
      
    }
  }
`
const NetWorkBtn = styled.div`
  display: flex;
  align-items: center;
  padding: 0 11px 0 17px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  height: 40px;
  line-height: 40px;  
  margin-right: 8px;  
  cursor: pointer;  
`

const ConnectBtn = styled.div`
  display: flex;
  align-items: center;
  padding: 0 14px 0 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  height: 40px;
  line-height: 40px;  
  cursor: pointer;    
  .exit-svg{
    padding-left:8px;
  }
  .btn-text{
    color: #32DE86;
    font-weight: 600;
    font-size: 16px;
  }
`
const ConnectBtn2 = styled.div`
  width: 130px;
  height: 42px;
  line-height: 42px;  
  background: #32DE86;  
  text-align: center;
  cursor: pointer;
  border-radius:8px;
  .btn-text{
    color: #fff;
    font-weight: 600;
    font-size: 16px;  
  }
`
